/**
 * xxl - Extra Extra Large
 * xl - Extra Large
 * lg - Large
 * md - Medium
 * sm - Small
 * xs - Extra Small
 */
const breakpoints = {
    xxl: '1400px',
    xl: '1200px',
    lg: '1025px',
    md: '768px',
    sm: '576px',
    xs: '320px',
};

export default breakpoints;
